import React, { createContext, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { API_URL } from '../config'
import { useAuth0 } from '@auth0/auth0-react'

const OrgSettingsContext = createContext()

export const useOrgSettings = () => {
    return useContext(OrgSettingsContext)
}

export const OrgSettingsProvider = ({ children }) => {
    const [orgSettings, setOrgSettings] = useState({
        homePageTables: {},
        aiAgentTenantId: null,
    })
    const [loading, setLoading] = useState(true)
    const { user } = useAuth0()

    const fetchOrgSettings = async () => {
        try {
            if (user?.email) {
                // Ensure Authorization header is set
                axios.defaults.headers.common['Authorization'] = user.email
                const response = await axios.get(`${API_URL}/api/organization/v1/settings`)
                // The API now returns: { data: { ...homePageTables, aiAgentTenantId: '...' } }
                // We want to separate them for cleaner context usage if we want, 
                // OR just keep them as the API returns. 
                // Let's parse it out for clarity in the state.

                const { aiAgentTenantId, ...tables } = response.data.data || {}

                setOrgSettings({
                    homePageTables: tables,
                    aiAgentTenantId: aiAgentTenantId,
                })
            }
        } catch (error) {
            console.error('Error fetching org settings:', error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (user?.email) {
            fetchOrgSettings()
        } else {
            setLoading(false)
        }
    }, [user])

    const value = {
        ...orgSettings,
        loading,
        refetchOrgSettings: fetchOrgSettings
    }

    return <OrgSettingsContext.Provider value={value}>{children}</OrgSettingsContext.Provider>
}

export default OrgSettingsProvider
